import { LinkButton } from '@cian/ui-kit/button';
import { Map16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectMapBannerExperimentEnabled } from '../../../../selectors/experiments/selectMapBannerExperimentEnabled';
import { selectOffersCount, selectQueryString } from '../../../../selectors/results';
import { SummaryButtonWrapper } from '../../../components/Summary';
import { trackMapViewButtonClicked } from '../utils/tracking';

export function SummaryMapViewButtonContainer() {
  const offerCount = useSelector(selectOffersCount);
  const queryString = useSelector(selectQueryString);
  const isNewMapBanner = useSelector(selectMapBannerExperimentEnabled);
  const href = React.useMemo(() => ['/map/', queryString].filter(Boolean).join('?'), [queryString]);

  if (isNewMapBanner || offerCount === 0) {
    return null;
  }

  return (
    <SummaryButtonWrapper>
      <LinkButton
        href={href}
        target="_blank"
        size="XS"
        theme="fill_white_primary"
        beforeIcon={<Map16 color="primary_100" />}
        onClick={trackMapViewButtonClicked}
      >
        На карте
      </LinkButton>
    </SummaryButtonWrapper>
  );
}
